<script setup lang="ts">
import { Minus, Plus } from '@lucide/vue'

interface IItems {
  id: string
  name: string
  iconType?: 'add' | 'remove'
}

withDefaults(defineProps<IItems>(), {
  id: '',
  name: '',
  iconType: 'add',
})

const emit = defineEmits<{ linkPressed: [id: string, name: string] }>()

const linkPressHandler = (id: string, name: string) => emit('linkPressed', id, name)
</script>

<template>
  <div
    class="flex items-center mb-2 justify-between gap-3 bg-white py-3 transition-colors hover:border-primary/30 dark:border-gray-700 dark:bg-white/3"
  >
    <div class="flex min-w-0 items-center gap-3">
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-800 dark:text-white/90">{{ name }}</p>
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ id }}</p>
      </div>
    </div>

    <button
      type="button"
      @click="linkPressHandler(id, name)"
      :class="[
        'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gray-200 text-gray-400 transition-colors dark:border-gray-700 dark:text-gray-400',
        iconType === 'remove'
          ? 'hover:border-red-300 hover:text-red-500'
          : 'hover:border-primary hover:text-primary',
      ]"
    >
      <Minus v-if="iconType === 'remove'" class="h-3.5 w-3.5" />
      <Plus v-if="iconType === 'add'" class="h-3.5 w-3.5" />
    </button>
  </div>
</template>
